import { SelectionItem } from "@/forms/ViewModelFormTypes";
import { StoreItem } from "../services/StoreItemGraphQLService";

export class StoreItemsListViewModel {
  public itemsPerPage = 25;
  public search = "";

  public storeFilter: {
    selected: string[];
    items: SelectionItem[];
  } = {
    selected: [],
    items: []
  };
  public itemTemplateFilter: {
    selected: string[];
    items: SelectionItem[];
  } = {
    selected: [],
    items: []
  };

  public headers = [
    { text: "Artikelnummer", value: "itemTemplate.itemNumber" },
    { text: "Bezeichnung", value: "itemTemplate.name" },
    { text: "Abmessung", value: "itemTemplate.dimensions" },
    { text: "Mindestmenge", value: "minimalAmount" },
    { text: "Lagerbestand", value: "amount" },
    { text: "Lager", value: "store.name" },
    { text: "", value: "actions", align: "right" }
  ];
  public items: StoreItem[] = [];
  public totalItems = 0;
  public options = {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: this.itemsPerPage,
    multiSort: true,
    mustSort: false,
    sortBy: [],
    sortDesc: []
  };
  public loading = true;
  public pageNumber = 1;
}
